import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { contentWidthStyles } from "@store/theme/common/mixins";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: TopHeaderContainerStyles;
}

export interface TopHeaderContainerStyles {
    container?: GridContainerProps;
    wrapper?: InjectableCss;
    langGridItem?: GridItemProps;
}

export const topHeaderContainerStyles: TopHeaderContainerStyles = {
    container: {
        gap: 0,
        css: css`
            background-color: ${getColor("user.guest")};
        `,
    },
    wrapper: {
        css: css`
            ${contentWidthStyles()}
            width: 100%;
        `,
    },
    langGridItem: {
        width: 12,
        align: "middle",
        css: css`
            > div {
                display: flex;

                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: ["space-between", null, null, "flex-end", null], properties: ["justify-content"] }],
                        mediaOptions.min,
                    )}
            }
        `,
    },
};

const StoreTopHeaderContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(topHeaderContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.container} className="topHeaderSection">
            <StyledWrapper {...styles.wrapper}>
                <GridItem {...styles.langGridItem}>
                    <Zone zoneName="Language" contentId={id} />
                </GridItem>
            </StyledWrapper>
        </GridContainer>
    );
};

const storeTopHeaderContainer: WidgetModule = {
    component: StoreTopHeaderContainer,
    definition: {
        group: "Header",
        isSystem: true,
    },
};

export default storeTopHeaderContainer;
